import{createContext as t}from"react";const o=t({});export{o as default};
//# sourceMappingURL=context.js.map
